import styled, { css } from 'styled-components';
const verticalMixin = css `
  @apply w-px h-6 my-0 mx-3;
`;
export const Container = styled.div `
  @apply h-px my-3 mx-0;

  width: ${(props) => props.width || '100%'};
  background-color: ${() => 'var(--border-color)'};
  ${(props) => (props.type === 'vertical' ? verticalMixin : undefined)};
`;
